import { IconButton, Skeleton } from "@mui/material";
import React, { useState } from "react";

const MuiIconButton = React.forwardRef(({ src, alt = "Icon Button", onClick, size, sx, ...rest }, ref) => {
  const [iconLoaded, setIconLoaded] = useState(false);

  return (
    <IconButton
      ref={ref}
      sx={{ height: size, width: size, p: 0, ...sx }}
      onClick={onClick}
      {...rest}
    >
      {!iconLoaded && (
        <Skeleton
          variant="circular"
          width={size}
          height={size}
        />
      )}
      <img
        src={src}
        alt={alt}
        className="img-full"
        onLoad={() => setIconLoaded(true)}
        style={{ display: iconLoaded ? "block" : "none" }}
      />
    </IconButton>
  );
});

MuiIconButton.displayName = "MuiIconButton";

export default MuiIconButton;
